<div *appRole="['Movimientos.Ver']" class="dialog-container">
  <ngx-spinner [zIndex]=100 name="spMovimiento" bdColor="rgba(255,255,255,0.8)" size="default" color="#009688"
    type="ball-atom" [fullScreen]="false">
  </ngx-spinner>

  <button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>

  <h1 mat-dialog-title>Ver <strong>movimiento</strong></h1>
  <mat-divider></mat-divider>
  <br>

  <div mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="movimientoDetailDto">

    <mat-tab-group animationDuration="0ms">

      <!-- ============================ DATOS GENERALES ============================ -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">info</mat-icon>
          Datos Generales
        </ng-template>

        <div class="tab-content">

          <!-- MOVIMIENTO -->
          <mat-card class="mb-3 p-3">
            <div class="section-title">
              <mat-icon color="primary">swap_horiz</mat-icon>
              <h3>Movimiento</h3>
            </div>
            <mat-divider></mat-divider>

            <div class="row mt-3">
              <div class="col-lg-3">
                <span class="label">Tipo</span>
                <span class="value con-icono">
                  <mat-icon color="primary">
                    {{ movimientoDetailDto.tipoMovimiento?.icono || 'swap_horiz' }}
                  </mat-icon>
                  {{ movimientoDetailDto.tipoMovimiento?.descripcion || '-' }}
                </span>
              </div>
              <div class="col-lg-3">
                <span class="label">Importe</span>
                <span class="value importe"
                  [class.negativo]="movimientoDetailDto.importe < 0">{{ movimientoDetailDto.importe | currency }}</span>
              </div>
              <div class="col-lg-3">
                <span class="label">Origen</span>
                <span class="value">{{ movimientoDetailDto.origenMovimiento || '-' }}</span>
              </div>
              <div class="col-lg-3">
                <span class="label">Estado</span>
                <span class="value">
                  <mat-chip-list>
                    <mat-chip *ngIf="movimientoDetailDto.anulado" color="warn" selected>Anulado</mat-chip>
                    <mat-chip *ngIf="!movimientoDetailDto.anulado" color="primary" selected>Vigente</mat-chip>
                  </mat-chip-list>
                </span>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-lg-3">
                <span class="label">Fecha Emisión</span>
                <span class="value">{{ movimientoDetailDto.fechaEmision ? (movimientoDetailDto.fechaEmision | date:'dd/MM/yyyy') : '-' }}</span>
              </div>
              <div class="col-lg-3">
                <span class="label">Fecha Pago</span>
                <span class="value">{{ movimientoDetailDto.fechaPago ? (movimientoDetailDto.fechaPago | date:'dd/MM/yyyy') : '-' }}</span>
              </div>
              <div class="col-lg-3">
                <span class="label">Fecha Vencimiento</span>
                <span class="value">{{ movimientoDetailDto.fechaVencimiento ? (movimientoDetailDto.fechaVencimiento | date:'dd/MM/yyyy') : '-' }}</span>
              </div>
            </div>

            <div class="row mt-3" *ngIf="movimientoDetailDto.descripcion">
              <div class="col-lg-12">
                <span class="label">Descripción</span>
                <span class="value">{{ movimientoDetailDto.descripcion }}</span>
              </div>
            </div>
          </mat-card>

          <!-- PERIODO Y CONTRATO -->
          <mat-card class="mb-3 p-3">
            <div class="section-title">
              <mat-icon color="primary">event</mat-icon>
              <h3>Período y Contrato</h3>
            </div>
            <mat-divider></mat-divider>

            <div class="row mt-3">
              <div class="col-lg-3">
                <span class="label">Mes / Año</span>
                <span class="value">{{ movimientoDetailDto.periodoMes || '-' }}/{{ movimientoDetailDto.periodoAnio || '-' }}</span>
              </div>
              <div class="col-lg-3">
                <span class="label">Período Contrato</span>
                <span class="value" *ngIf="movimientoDetailDto.periodoContrato; else sinPeriodo">
                  {{ movimientoDetailDto.periodoContrato?.periodoMes }}/{{ movimientoDetailDto.periodoContrato?.periodoAnio }}
                  &mdash; {{ movimientoDetailDto.periodoContrato?.importeAlquiler | currency }}
                </span>
                <ng-template #sinPeriodo><span class="value">-</span></ng-template>
              </div>
              <div class="col-lg-6">
                <span class="label">Contrato</span>
                <span class="value">{{ movimientoDetailDto.contrato?.descripcion || '-' }}</span>
              </div>
            </div>
          </mat-card>

          <!-- PERSONAS Y PROPIEDAD -->
          <mat-card class="mb-3 p-3">
            <div class="section-title">
              <mat-icon color="primary">people</mat-icon>
              <h3>Personas y Propiedad</h3>
            </div>
            <mat-divider></mat-divider>

            <div class="row mt-3">
              <div class="col-lg-4">
                <span class="label">Propietario</span>
                <span class="value">{{ movimientoDetailDto.propietario?.descripcion || '-' }}</span>
              </div>
              <div class="col-lg-4">
                <span class="label">Inquilino</span>
                <span class="value">{{ movimientoDetailDto.inquilino?.descripcion || '-' }}</span>
              </div>
              <div class="col-lg-4">
                <span class="label">Propiedad</span>
                <span class="value">{{ movimientoDetailDto.propiedad?.descripcion || '-' }}</span>
              </div>
            </div>
          </mat-card>

          <!-- BONIFICACION -->
          <mat-card class="mb-3 p-3" *ngIf="movimientoDetailDto.bonificacion">
            <div class="section-title">
              <mat-icon color="primary">local_offer</mat-icon>
              <h3>Bonificación</h3>
            </div>
            <mat-divider></mat-divider>

            <div class="row mt-3">
              <div class="col-lg-6">
                <span class="label">Tipo</span>
                <span class="value">{{ movimientoDetailDto.bonificacion?.tipoBonificacion?.descripcion || '-' }}</span>
              </div>
              <div class="col-lg-6">
                <span class="label">Detalle</span>
                <span class="value">{{ movimientoDetailDto.bonificacion?.detalle || '-' }}</span>
              </div>
            </div>
          </mat-card>

        </div>
      </mat-tab>

      <!-- ============================== COMPROBANTES ============================== -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">receipt_long</mat-icon>
          Comprobantes
          <span class="badge-contador" *ngIf="comprobantesVinculados.length > 0">{{ comprobantesVinculados.length }}</span>
        </ng-template>

        <div class="tab-content">
          <mat-card class="mb-3 p-3">
            <div class="section-title">
              <mat-icon color="primary">account_tree</mat-icon>
              <h3>Trazabilidad</h3>
            </div>
            <mat-divider></mat-divider>

            <app-sin-datos *ngIf="comprobantesVinculados.length === 0"
              icono="link_off"
              mensaje="Sin comprobantes vinculados"
              detalle="Este movimiento todavía no entró en ningún recibo ni liquidación."
              [compacto]="true">
            </app-sin-datos>

            <table mat-table [dataSource]="comprobantesVinculados" class="mt-3 w-100"
              *ngIf="comprobantesVinculados.length > 0">

              <ng-container matColumnDef="tipoVinculo">
                <th mat-header-cell *matHeaderCellDef>Vínculo</th>
                <td mat-cell *matCellDef="let element">
                  <span class="with-icon">
                    <mat-icon [color]="colorVinculo(element.tipoVinculo)">{{ iconoVinculo(element.tipoVinculo) }}</mat-icon>
                    {{ element.tipoVinculo }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="nroComprobante">
                <th mat-header-cell *matHeaderCellDef>Nro.</th>
                <td mat-cell *matCellDef="let element">{{ element.nroComprobante || '-' }}</td>
              </ng-container>

              <ng-container matColumnDef="tipoComprobante">
                <th mat-header-cell *matHeaderCellDef>Tipo</th>
                <td mat-cell *matCellDef="let element">{{ element.tipoComprobante || '-' }}</td>
              </ng-container>

              <ng-container matColumnDef="fechaEmision">
                <th mat-header-cell *matHeaderCellDef>Fecha</th>
                <td mat-cell *matCellDef="let element">{{ element.fechaEmision | date:'dd/MM/yyyy' }}</td>
              </ng-container>

              <ng-container matColumnDef="estadoComprobante">
                <th mat-header-cell *matHeaderCellDef>Estado</th>
                <td mat-cell *matCellDef="let element">{{ element.estadoComprobante || '-' }}</td>
              </ng-container>

              <ng-container matColumnDef="importeImputado">
                <th mat-header-cell *matHeaderCellDef class="text-right">Importe imputado</th>
                <td mat-cell *matCellDef="let element" class="text-right">
                  {{ element.importeImputado != null ? (element.importeImputado | currency) : '-' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="accion">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                  <button mat-icon-button color="primary" (click)="verComprobante(element)"
                    matTooltip="Ver comprobante">
                    <mat-icon>open_in_new</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumnsComprobantes"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsComprobantes;"></tr>
            </table>
          </mat-card>
        </div>
      </mat-tab>

      <!-- =============================== AUDITORÍA =============================== -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">history</mat-icon>
          Auditoría
        </ng-template>

        <div class="tab-content">
          <!-- Antes eran tres fechas sueltas leídas del propio movimiento. Ahora
               el bloque es compartido y trae también QUIÉN, la anulación y el
               acceso al historial campo por campo. -->
          <app-info-auditoria entidad="Movimientos" [id]="movimientoDetailDto.id">
          </app-info-auditoria>
        </div>
      </mat-tab>

    </mat-tab-group>
  </div>
</div>
